
import FormPreview from 'vux/src/components/form-preview/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
FormPreview,
XTable
},
data () {
return {
list: []
}
},
activated: function () {
this.list = [ {
label: '集装箱规格型号名称',
value: this.$route.params.CM_NAME
}, {
label: '集装箱规格型号说明',
value: this.$route.params.CM_Remark
}]
console.log(this.$route.params)
}
}



// WEBPACK FOOTER //
// ./src/components/P_ContainerModelsDetail.vue